module.exports = __webpack_public_path__ + "img/contact_icon.7d3c0cbf.svg";